"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelrotto": {
    "65dd97bc": [{
      "hkey": "3a5bc757",
      "slug": "campaccio-alpe-di-siusi",
      "name": "Campaccio (Alpe di Siusi)",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-di-siusi": [{
      "hkey": "3a5bc757",
      "slug": "campaccio-alpe-di-siusi",
      "name": "Campaccio (Alpe di Siusi)",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "609240e1": [{
      "hkey": "172f8ebc",
      "slug": "castelrotto",
      "name": "Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "san-valentino": [{
      "hkey": "172f8ebc",
      "slug": "castelrotto",
      "name": "Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fceae5db": [{
      "hkey": "172f8ebc",
      "slug": "castelrotto",
      "name": "Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "san-vigilio": [{
      "hkey": "172f8ebc",
      "slug": "castelrotto",
      "name": "Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "205a60f1": [{
      "hkey": "172f8ebc",
      "slug": "castelrotto",
      "name": "Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "sant-osvaldo": [{
      "hkey": "172f8ebc",
      "slug": "castelrotto",
      "name": "Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;